<template>
   <CollapseCard title="Company Information" ident="company-info">
      <b-table id="table-company-info" :items="tableItems" :fields="fields" class="mt-3 mb-0">
         <template #head(value)="data">
            <div class="cell-w-buttons">
               {{ data.label }}
               <b-button
                  id="btn-edit-info"
                  variant="primary"
                  class="ml-2"
                  size="sm"
                  :to="{name: 'company-edit', params: {id: $companyId}}"
               >
                  Edit Info
               </b-button>
            </div>
         </template>
         <template #cell(key)="data">
            <b>{{ data.value }}</b>
         </template>
      </b-table>
   </CollapseCard>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
   data() {
      return {
         fields: [{key: 'key', label: 'Field', sortable: true}, 'value'],
         companyAttrs: [
            {key: 'companyName'},
            {key: 'fein', label: 'FEIN#'},
            {key: 'incorporated', label: 'Date of Incorporation', formatter: this.formatDate},
            {key: 'entityType', formatter: this.formatEntityType},
            {key: 'industryId', label: 'Industry', formatter: this.formatIndustry},
            {
               key: 'filingDeadlineMonth',
               label: 'Filing Deadline',
               formatter: (value) => this.formatMonthDay(value, this.company.filingDeadlineDay),
            },
            {
               key: 'taxYearEndMonth',
               label: 'Tax Year End',
               formatter: (value) => this.formatMonthDay(value, this.company.taxYearEndDay),
            },
            {key: 'payrollTaxElection', formatter: this.formatBoolean},
            {key: 'stateCredits', label: 'State Credits', formatter: this.formatStateCredits},
            {
               key: 'firstRndEffort',
               label: 'Year of First R&D Effort',
               formatter: this.formatTaxYear,
            },
            {key: 'startupYear', label: 'Startup Year', formatter: this.formatStartupYear},
            {key: 'cpaInfo', label: 'CPA Name', formatter: this.subAttr('name')},
            {key: 'cpaInfo', label: 'CPA Firm', formatter: this.subAttr('firm')},
            {key: 'cpaInfo', label: 'CPA Email', formatter: this.subAttr('email')},
            {key: 'contactInfo', label: 'Contact Name', formatter: this.subAttr('name')},
            {key: 'contactInfo', label: 'Contact Email', formatter: this.subAttr('email')},
         ],
      };
   },

   computed: {
      ...mapGetters({
         company: 'companies/currentCompany',
         industryMap: 'industries/industryMap',
      }),

      tableItems() {
         let items = [];

         for (const attr of this.companyAttrs) {
            var {key, label, formatter} = attr;
            const value = this.company[key];

            if (label === undefined) {
               // convert camelcase to sentence
               label = key.replace(/[A-Z]/g, ' $&');
               label = label.charAt(0).toUpperCase() + label.slice(1);
            }

            const formattedValue = formatter ? formatter(value) : value;

            items.push({key: label, value: formattedValue});
         }

         return items;
      },
   },

   methods: {
      formatIndustry(value) {
         if (null === this.industryMap) {
            return value;
         } else {
            return this.industryMap[value]?.name;
         }
      },

      formatEntityType(value) {
         if (value) {
            const entityTypeMap = {
               S_CORP: 'S Corp',
               C_CORP: 'C Corp',
               PARTNERSHIP: 'Partnership',
            };
            return entityTypeMap[value];
         } else {
            return value;
         }
      },

      formatStateCredits(value) {
         return value.map((state) => state.toUpperCase()).join(', ');
      },

      formatMonthDay(month, day) {
         if (!month || !day) {
            return null;
         }
         return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
      },

      formatTaxYear(value) {
         if (this.$constants().MIN_TAX_YEAR === value) {
            return `${this.$constants().MIN_TAX_YEAR} or prior`;
         }
         return value;
      },

      formatBoolean(value) {
         return value ? 'yes' : 'no';
      },

      formatDate(value) {
         if (value) {
            return value.toLocaleDateString();
         }
         return value;
      },

      formatStartupYear(value) {
         if (!value?.lower) return null;
         return `${value.lower} to ${value.upper}`;
      },

      subAttr(key) {
         return (obj) => obj[key];
      },
   },
};
</script>
